import { render, staticRenderFns } from "./value.vue?vue&type=template&id=48f152a8&scoped=true"
import script from "./value.vue?vue&type=script&lang=js"
export * from "./value.vue?vue&type=script&lang=js"
import style0 from "./value.vue?vue&type=style&index=0&id=48f152a8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f152a8",
  null
  
)

export default component.exports